<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <div class="man-cell" style="width:350px">
        <el-date-picker
          v-model="stime"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <el-button type="primary" @click="changeData(stime[0],stime[1])">搜索</el-button>
      <el-table :data="tableData" highlight-current-row style="width:100%" v-loading="loading">
        <el-table-column property="order" label="订单号"></el-table-column>
        <el-table-column property="time" label="日期"></el-table-column>
        <el-table-column property="type" label="类型"></el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
        <el-table-column label="金额(元)">
          <template slot-scope="scope">
            <a style="color:red" v-if="!scope.row.add">-{{scope.row.price}}</a>
            <a style="color:green" v-else>+{{scope.row.price}}</a>
          </template>
        </el-table-column>
        <el-table-column property="sum" label="账户余额"></el-table-column>
      </el-table>
      <div class="Pagination" style="text-align: left;margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="index"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";

export default {
  data() {
    return {
      stime: ["", ""],
      username: localStorage.getItem("username"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      sousuo: ""
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.getdetailed();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getdetailed();
    },
    async getdetailed() {
      myAxios
        .get(
          `client_user/BillDetails/v1?username=${this.username}&index=${this.index}&size=${this.size}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    changeData(time1, time2) {
      myAxios
        .get(
          `client_user/BillDetails/v1?username=${this.username}&starTime=${time1}&endTime=${time2}&index=${this.index}&size=${this.size}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
</style>
